export default "__VITE_ASSET__C7rIDZ6x__"